import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SharedService } from '../shared/shared.service';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class PostLoginSsaService implements CanActivate{



  SERVER_URL= environment.backend_server;

  auth_key:any;

  constructor(
    public http:HttpClient,
    public router:Router,
    private shared_service:SharedService,
    private auth_service:AuthenticationService,
  ) { }


  canActivate(route:ActivatedRouteSnapshot,state:RouterStateSnapshot):boolean | Observable<boolean>| Promise<boolean | UrlTree>{
    
   

    return new Promise (res =>{ 

      if(this.auth_service.isLoggedIn()['isLoggedIn']){

        if(this.auth_service.isLoggedIn()['user_data']['type_1']=='Admin'){
               this.auth_service.removeTokenSession();
            this.router.navigate(['/login']);
            res(false);
        }else{

           
             res(true);

        }
        
        // this.shared_service.getUserData.subscribe(user_data =>{
        //   if(user_data['type_1']=='Admin'){  
            
        //     this.auth_service.removeTokenSession();
        //     this.router.navigate(['/login']);
        //     res(false);
        //   }else{
            
           
        //    res(true);
  
        //    }
         
        // });
  
         
        
      }else{
        
        this.router.navigate(['/login']);
        res(false);
      }


    });
    
  }
}

